/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useRef } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';

import { isWeb } from '@global/screens';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';
import SociollaTable from '@components/sociolla/SociollaTable';
import ModalFull from '@components/modal/ModalFull';
import { getAttibutes, isVn } from '@global/helpers';
import { getProductsFromEs, getProductsCountFromEs } from '@api/ms-b2b';
import { getProductCount, getProducts } from '@api/ms-catalog';
import tableApi from '@/hooks/tableApi';
import Colors from '@global/colors';
import PropTypes from 'prop-types';

const propTypes = {
  show: PropTypes.bool,
};

const defaultProps = {
  show: false,
};

const HEADER_DEKSTOP = [
  {
    label: 'Product Image',
    data: 'image',
    type: 'image',
    width: '15%',
    styleItem: {
      alignItems: 'center',
      padding: 0,
      margin: 0,
    },
  },
  {
    label: 'Internal Reference',
    data: 'reference',
    width: '25%',
    numberOfLines: 2,
  },
  {
    label: 'Name',
    data: 'name',
    width: '25%',
    numberOfLines: 3,
  },
  {
    label: 'Attribute Value',
    data: 'attributes',
    width: '35%',
    numberOfLines: 2,
  },
];

const defaultPhoto = require('@/assets/img/default/user-default.png');

const SelectProductTable = (props) => {
  const { show = false } = props;

  const tableRef = useRef();

  const [emptyLabel, setEmptyLabel] = useState('Please search any product.');
  const [paramsTable, setParamsTable] = useState({
    filter: {},
    limit: isWeb ? 10 : 15,
    skip: 0,
  });
  const [list, setList] = useState([]);
  const [loadingMore, setLoadingMore] = useState(false);

  const get_products = tableApi(
    getProductCount,
    getProducts,
    getProductsCountFromEs,
    getProductsFromEs,
  );

  const callBackRowPress = (item) => {
    // eslint-disable-next-line react/prop-types
    props.onCallback(item.item);
  };

  const onSearchTable = async (param, type) => {
    const params = { ...paramsTable };
    if (type === 'keyword') {
      if (param.keyword.length > 2) {
        params.filter['keyword'] = param.keyword;
      } else if (!param.keyword) {
        delete params.filter['keyword'];
        setEmptyLabel('Please search any product.');
        setList([]);
        return;
      }
    } else if (type === 'pagination') {
      setLoadingMore(true);
      params.limit = param.limit;
      params.skip = param.skip;
    }
    await setParamsTable({ ...params });
    apiProduct(params);
  };

  const apiProduct = (params = null) => {
    const param = params ? params : { ...paramsTable };
    const hasFilter = Object.keys(param?.filter || {}).length ? true : false;
    get_products.request(param, null, hasFilter).then((response) => {
      if (response) {
        if (!response.length) {
          setEmptyLabel('No data found.');
        }
        if (param.skip > 0) {
          setList([...list, ...generateData(response)]);
        } else {
          setList(generateData(response));
        }
        setLoadingMore(false);
      }
    });
  };

  const getImage = (image) => {
    let img = '';
    if (image?.length) {
      for (let index = 0; index < image.length; index++) {
        if (index === 0) {
          img = image[index].url;
        }
        if (image[index].is_cover) {
          img = image[index].url;
        }
      }
    }
    return img;
  };

  const generateData = (data) => {
    const products = [];
    for (let index = 0; index < data.length; index++) {
      const prod = data[index];
      for (let index2 = 0; index2 < prod.combinations.length; index2++) {
        const prodCombi = prod.combinations[index2];
        const combi = { name: prod.name, brand: prod.brand };
        combi.reference = prodCombi.reference || '';
        combi.id = prod.id;
        combi.image = getImage(prodCombi.images);
        combi.attributes = getAttibutes(prodCombi.attributes);
        combi.product_combination_id = prodCombi._id;
        combi.price = prodCombi.price;
        combi.ref_name = '[' + combi.reference + '] ' + combi.name;
        if (
          isVn() ? prodCombi.is_active_in_b2b_vn : prodCombi.is_active_in_b2b
        ) {
          products.push(combi);
        }
      }
    }
    return products;
  };

  const renderItem = ({ item, index }) => (
    <TouchableOpacity
      onPress={() => callBackRowPress({ item })}
      key={'list-product-' + index}
      style={styles.tableRow}>
      <View style={styles.productItem}>
        <View style={{ width: '20%' }}>
          <Image
            source={{ uri: `${item.image ? item.image : defaultPhoto}` }}
            style={{ width: 36, height: 36 }}
            width={36}
            height={36}
            defaultSource={defaultPhoto}
          />
        </View>
        <View style={{ width: '80%' }}>
          <SociollaText
            type="medium"
            style={styles.productName}
            numberOfLines={1}>
            {item.name}
          </SociollaText>
          <SociollaText style={styles.productReference}>
            {item.reference}
          </SociollaText>
          <SociollaText
            type="medium"
            style={styles.productPrice}
            currency={true}>
            {item.price}
          </SociollaText>
        </View>
      </View>
    </TouchableOpacity>
  );

  const onClose = () => {
    try {
      // eslint-disable-next-line react/prop-types
      props.onClose();
    } catch (err) {}
  };

  return (
    <ModalFull
      title={'Select Product'}
      show={show ? true : false}
      onClose={() => onClose()}
      width={isWeb ? 1000 : '100%'}>
      <View style={styles.tableContainer}>
        {isWeb && (
          <SociollaTable
            table={HEADER_DEKSTOP}
            ref={tableRef}
            datas={list}
            showSearch={true}
            searchBorder={true}
            scrollItem={true}
            maxHeight={320}
            threshold={0.3}
            stickyHeaderIndices={[0]}
            searchPlaceholder="Search by Name, SKU or Brands"
            emptyLabel={emptyLabel}
            count={get_products.count}
            loading={get_products.loading}
            loadingLoadMore={loadingMore}
            callBackRowPress={callBackRowPress}
            onSearchTable={(val, type) => onSearchTable(val, type)}
            localParams={paramsTable}
          />
        )}
        {!isWeb && (
          <SociollaTable
            datas={list}
            itemComponent={renderItem}
            headerComponent={<></>}
            showSearch={true}
            loading={get_products.loading}
            count={get_products.count}
            scrollItem={true}
            loadingLoadMore={loadingMore}
            searchPlaceholder="Search by Name, SKU or Brands"
            onSearchTable={(val, type) => onSearchTable(val, type)}
            localParams={paramsTable}
          />
        )}
      </View>
    </ModalFull>
  );
};

const styles = StyleSheet.create({
  tableRow: {
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexDirection: 'column',
    height: 90,
    width: '100%',
    flex: 1,
    borderBottomColor: Colors.grey9,
    borderBottomWidth: 1,
    paddingHorizontal: 20,
  },
  tableContainer: isWeb
    ? {
        backgroundColor: Colors.grey11,
        paddingHorizontal: 35,
        paddingVertical: 20,
      }
    : { flex: 1, backgroundColor: Colors.white },
  productItem: { flexDirection: 'row', width: '100%', alignItems: 'center' },
  productName: { fontSize: 14, color: Colors.black1, paddingBottom: 8 },
  productReference: { fontSize: 12, color: Colors.black5, paddingBottom: 9 },
  productPrice: { fontSize: 14, color: Colors.black1 },
});

SelectProductTable.propTypes = propTypes;
SelectProductTable.defaultProps = defaultProps;

export default React.memo(SelectProductTable, (prev, next) => prev == next);
